import { Component } from "react";
import { connect } from "react-redux";
import { reEdit, cancel } from "../../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class ConfirmedAbsence extends Component {
    reEdit() {
        this.props.reEdit(this.props.absences, this.props.activeUser);
    }

    cancel() {
        this.props.cancel(this.props.absences, this.props.activeUser);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-1 col-md-2 col-sm-4 col-6">
                        <Fab
                            onClick={this.reEdit.bind(this)}
                            color="primary"
                            className="div-center"
                        >
                            <Icon>edit</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">
                            Ré-éditer
                        </span>
                    </div>
                    <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                        <div className="center">
                            <Fab
                                onClick={this.cancel.bind(this)}
                                className="red-button div-center"
                            >
                                <Icon>block</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">
                                Annuler
                            </span>
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reEdit: (absencesState, activeUser) =>
            dispatch(reEdit(absencesState, activeUser)),
        cancel: (absencesState, activeUser) =>
            dispatch(cancel(absencesState, activeUser)),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ConfirmedAbsence);
